export function parsePipes(commandString):Array<Command>{
  //remove whitespace before and remove whitespace after
  let command = commandString.trim();
  //split into pipes
  let result = [];
  let cmds = command.split('|');
  // parse each one
  for(let i=0; i<cmds.length; i++){
    result.push(this.parseSingleCommand(cmds[i]))
  }
  return result;
}


export interface Command{
  commandString:string;
  command:string;
  substring?:string;
  arguments?:Object;
}

export class SimpleCommand implements Command{

    commandString:string;
    command:string;
    substring?:string;
    arguments?:Object;

    public static parsePipes= parsePipes;

    public static parseSingleCommand(cmdString):SimpleCommand {
      //discover options and arguments
      let commandString:string = cmdString.trim().toString();
      //check if command contains a space- then there's a subcommand "e.g. create participant"
      let command:string = commandString.split(' ')[0];
      let substring:string = commandString.substr(commandString.indexOf(' ') + 1);
      // if(command==="") { command = substring; substring=""}
      return {command, substring, commandString};
    }

  public static parseArguments(argumentString):Object{
    //make sure you start from the first -
    let argString = argumentString.substr(argumentString.indexOf('-'));
    let argList = argString.split('-');
    let myArguments = {};
    for (let i = 0; i < argList.length; i++) {
      let currentArgument = argList[i];
      if (currentArgument.length){
        let argName = currentArgument.substr(0, currentArgument.indexOf(' '));
        let argVal = currentArgument.substr(currentArgument.indexOf(' ')+1);
        myArguments[argName] = argVal;
      }
    }

    return myArguments;
  }

}



// WEBPACK FOOTER //
// ./src/components/commands/command-parser.ts